export default {"src":"https://images-cdn.curipod.com/d-09a63bb9/_next/static/media/wake_county_wcpss.dd36f474.svg","height":67,"width":250};